/* tslint:disable */
import {
  Board
} from '../index';

declare var Object: any;
export interface BoardHistoryInterface {
  "boardId"?: number;
  "userAccountId": number;
  "uuid"?: string;
  "shareId"?: string;
  "name": string;
  "data"?: string;
  "grid"?: string;
  "tags"?: string;
  "active": boolean;
  "status": number;
  "createdAt": Date;
  "createdBy"?: number;
  "updatedAt": Date;
  "updatedBy"?: number;
  "arData"?: string;
  "modelId"?: string;
  "id"?: number;
  board?: Board;
}

export class BoardHistory implements BoardHistoryInterface {
  "boardId": number;
  "userAccountId": number;
  "uuid": string;
  "shareId": string;
  "name": string;
  "data": string;
  "grid": string;
  "tags": string;
  "active": boolean;
  "status": number;
  "createdAt": Date;
  "createdBy": number;
  "updatedAt": Date;
  "updatedBy": number;
  "arData": string;
  "modelId": string;
  "id": number;
  board: Board;
  constructor(data?: BoardHistoryInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `BoardHistory`.
   */
  public static getModelName() {
    return "BoardHistory";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of BoardHistory for dynamic purposes.
  **/
  public static factory(data: BoardHistoryInterface): BoardHistory{
    return new BoardHistory(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'BoardHistory',
      plural: 'BoardHistories',
      path: 'BoardHistories',
      idName: 'id',
      properties: {
        "boardId": {
          name: 'boardId',
          type: 'number'
        },
        "userAccountId": {
          name: 'userAccountId',
          type: 'number'
        },
        "uuid": {
          name: 'uuid',
          type: 'string'
        },
        "shareId": {
          name: 'shareId',
          type: 'string'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "data": {
          name: 'data',
          type: 'string'
        },
        "grid": {
          name: 'grid',
          type: 'string'
        },
        "tags": {
          name: 'tags',
          type: 'string'
        },
        "active": {
          name: 'active',
          type: 'boolean',
          default: true
        },
        "status": {
          name: 'status',
          type: 'number',
          default: 0
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'number'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "updatedBy": {
          name: 'updatedBy',
          type: 'number'
        },
        "arData": {
          name: 'arData',
          type: 'string'
        },
        "modelId": {
          name: 'modelId',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
        board: {
          name: 'board',
          type: 'Board',
          model: 'Board',
          relationType: 'belongsTo',
                  keyFrom: 'boardId',
          keyTo: 'id'
        },
      }
    }
  }
}
